import Vue from 'vue'
import VueRouter from 'vue-router'
import NotFound from './NotFound'
import Packages from './Packages.vue'
import Containers from './Containers.vue'
import PackageEditor from './PackageEditor.vue'

Vue.use(VueRouter)

let routes = [
  {
    path: '/',
    name: 'Containers',
    component: Containers
  },
  {
    path: '/packages/:consumer/:type',
    name: 'Packages',
    component: Packages
  },
  {
    path: '/packages/editor/:consumer/:type/:id',
    name: 'Packages editor',
    component: PackageEditor
  },
  {
    path: '/packages/editor/:consumer/:type',
    name: 'Packages new',
    component: PackageEditor
  }
]
routes.push({path: '*', component: NotFound})

export default new VueRouter({
  mode: 'hash',
  routes: routes
})
